/* eslint-disable no-param-reassign */
import { emailRegex } from '../util';
export const isEmail = (email) => emailRegex.test(email);
// The following string utilities came from: https://gist.github.com/jonlabelle/5375315
/**
 * Remove non-word chars.
 */
export const removeNonWord = (str) => str.replace(/[^0-9a-zA-Z\xC0-\xFF -]/g, '');
/**
 * Replaces all accented chars with regular ones
 */
export const replaceAccents = (str) => {
    // verifies if the String has accents and replace them
    if (str.search(/[\xC0-\xFF]/g) > -1) {
        str = str
            .replace(/[\xC0-\xC5]/g, 'A')
            .replace(/[\xC6]/g, 'AE')
            .replace(/[\xC7]/g, 'C')
            .replace(/[\xC8-\xCB]/g, 'E')
            .replace(/[\xCC-\xCF]/g, 'I')
            .replace(/[\xD0]/g, 'D')
            .replace(/[\xD1]/g, 'N')
            .replace(/[\xD2-\xD6\xD8]/g, 'O')
            .replace(/[\xD9-\xDC]/g, 'U')
            .replace(/[\xDD]/g, 'Y')
            .replace(/[\xDE]/g, 'P')
            .replace(/[\xE0-\xE5]/g, 'a')
            .replace(/[\xE6]/g, 'ae')
            .replace(/[\xE7]/g, 'c')
            .replace(/[\xE8-\xEB]/g, 'e')
            .replace(/[\xEC-\xEF]/g, 'i')
            .replace(/[\xF1]/g, 'n')
            .replace(/[\xF2-\xF6\xF8]/g, 'o')
            .replace(/[\xF9-\xFC]/g, 'u')
            .replace(/[\xFE]/g, 'p')
            .replace(/[\xFD\xFF]/g, 'y');
    }
    return str;
};
export const lowerCase = (str) => str.toLowerCase();
export const upperCase = (str) => str.toUpperCase();
export const camelCase = (str) => {
    str = replaceAccents(str);
    str = removeNonWord(str)
        .replace(/-/g, ' ') // convert all hyphens to spaces
        .replace(/\s[a-z]/g, upperCase) // convert first char of each word to UPPERCASE
        .replace(/\s+/g, '') // remove spaces
        .replace(/^[A-Z]/g, lowerCase); // convert first char to lowercase
    return str;
};
/**
 * Add space between camelCase text.
 */
export const unCamelCase = (str) => {
    str = str.replace(/([a-z\xE0-\xFF])([A-Z\xC0\xDF])/g, '$1 $2');
    str = str.toLowerCase(); // add space between camelCase text
    return str;
};
/**
 * UPPERCASE first char of each word.
 */
export const properCase = (str) => lowerCase(str).replace(/^\w|\s\w/g, upperCase);
/**
 * camelCase + UPPERCASE first char
 */
export const pascalCase = (str) => camelCase(str).replace(/^[a-z]/, upperCase);
/**
 * UPPERCASE first char of each sentence and lowercase other chars.
 */
export const sentenceCase = (str) => lowerCase(str).replace(/(^\w)|\.\s+(\w)/gm, upperCase);
/**
 * Convert to lower case, remove accents, remove non-word chars and
 * replace spaces with the specified delimiter.
 * Does not split camelCase text.
 */
export const slugify = (str, delimiter = '-') => {
    str = replaceAccents(str);
    str = removeNonWord(str);
    str = str.trim() // should come after removeNonWord
        .replace(/ +/g, delimiter) // replace spaces with delimiter
        .toLowerCase();
    return str;
};
/**
 * Replaces spaces with hyphens, split camelCase text, remove non-word chars, remove accents and convert to lower case.
 */
export const hyphenate = (str) => {
    str = unCamelCase(str);
    return slugify(str, '-');
};
/**
 * Replaces hyphens with spaces. (only hyphens between word chars)
 */
export const unhyphenate = (str) => str.replace(/(\w)(-)(\w)/g, '$1 $3');
/**
 * Replaces spaces with underscores, split camelCase text, remove
 * non-word chars, remove accents and convert to lower case.
 */
export const underscore = (str) => {
    str = unCamelCase(str);
    return slugify(str, '_');
};
/**
 * Searches for a given substring
 */
export const contains = (str, substring, fromIndex = 0) => str.indexOf(substring, fromIndex) !== -1;
/**
 * Limit number of chars.
 */
export const truncate = (str, maxChars, append, onlyFullWords) => {
    append = append || '...';
    maxChars = onlyFullWords ? maxChars + 1 : maxChars;
    str = str.trim();
    if (str.length <= maxChars) {
        return str;
    }
    str = str.substr(0, maxChars - append.length);
    // crop at last space or remove trailing whitespace
    str = onlyFullWords ? str.substr(0, str.lastIndexOf(' ')) : str.trim();
    return str + append;
};
/**
 * Truncate string at full words.
 */
export const crop = (str, maxChars, append) => truncate(str, maxChars, append, true);
/**
 * Escape RegExp string chars.
 */
export const escapeRegExp = (str) => {
    const ESCAPE_CHARS = /[\\.+*?^$[\](){}/'#]/g;
    return str.replace(ESCAPE_CHARS, '\\$&');
};
/**
 * Escapes a string for insertion into HTML.
 */
export const escapeHtml = (str) => (str.replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;'));
/**
 * Unescapes HTML special chars
 */
export const unescapeHtml = (str) => (str.replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&#39;/g, "'")
    .replace(/&quot;/g, '"'));
/**
 * Capture all capital letters following a word boundary (in case the
 * input is in all caps)
 */
export const abbreviate = (str) => str.match(/\b([A-Z])/g).join('');
